import { render, staticRenderFns } from "./Question1.vue?vue&type=template&id=2d724f3e&"
import script from "./Question1.vue?vue&type=script&lang=js&"
export * from "./Question1.vue?vue&type=script&lang=js&"
import style0 from "./Question1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
